module.exports = __webpack_public_path__ + "static/media/plantThree.29d3fa42.jpg";